export const getBrowserLanguageCode = () => {
  if (navigator.language.includes('ko')) {
    return 'ko'
  } else if (navigator.language.includes('ja')) {
    return 'jp'
  } else {
    return 'en'
  }
}
